export default __webpack_public_path__ + "files/2b42cd49a6ce0aaf2984675601554db4.jpg";